import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';

import SelectField from '../../common/components/SelectField';
import clientSelector from '../../clients/clientSelector';
import createCounselingCenterStatistics from './counselingCenter/createCounselingCenterStatistics';
import type { FhbfStatisticType } from '../../common/types/statistics/fhbfStatistics';
import type { StatisticsFilter as StatisticsFilterType } from '../../common/types/statistics/statistics';
import createInterventionCenterStatistics from './interventionCenter/createInterventionCenterStatistics';
import createInterventionCenterGovStatistics from './interventionCenterGov/createInterventionCenterGovStatistics';
import documentationSelector from '../../documentation/documentationSelector';

type Props = {
  location: string;
  filterStartYear: number;
  setStatistic: (statistic: FhbfStatisticType) => void;
  statisticFilter: StatisticsFilterType;
  setStatisticFilter: (statistic: StatisticsFilterType) => void;
};

function StatisticsFilter(props: Props) {
  const { location, filterStartYear, setStatistic, statisticFilter, setStatisticFilter } = props;

  const clients = useSelector(clientSelector.getClients);
  const documentation = useSelector(documentationSelector.getDocumentation);

  const currentYear = new Date().getFullYear();
  const yearDifference = currentYear - filterStartYear >= 0 ? currentYear - filterStartYear : 0;

  const years = new Array(yearDifference + 1).fill(0).map((_, index) => {
    const year = currentYear - index;
    return { label: `${year}`, value: `${year}` };
  });

  return (
    <Paper
      variant='outlined'
      className='statistic-filter-wrapper'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: '24px 0 48px 0',
        padding: '20px 24px',
        minWidth: '300px',
        maxWidth: '650px',
        backgroundColor: '#FAFAFA',
      }}
    >
      <Typography fontSize='1.2rem' mb={2}>
        Filter
      </Typography>
      <Grid container rowSpacing={2} columnSpacing={4}>
        <Grid item xs={6}>
          <SelectField
            label='Jahr'
            options={years}
            value={statisticFilter.year}
            fullWidth
            handleChange={(value) => {
              if (typeof value === 'string') {
                setStatisticFilter({ ...statisticFilter, year: value });
              }
            }}
          />
        </Grid>
      </Grid>
      <Button
        variant='contained'
        onClick={() => {
          if (clients != null) {
            if (location.toLowerCase().includes('fachberatungsstelle')) {
              const clientStatistics = createCounselingCenterStatistics(clients, documentation, statisticFilter);
              setStatistic(clientStatistics);
            }
            if (
              location.toLowerCase().includes('interventionsstelle') &&
              location.toLowerCase().includes('government')
            ) {
              const clientStatistics = createInterventionCenterGovStatistics(clients, documentation, statisticFilter);
              setStatistic(clientStatistics);
            } else if (location.toLowerCase().includes('interventionsstelle')) {
              const clientStatistics = createInterventionCenterStatistics(clients, documentation, statisticFilter);
              setStatistic(clientStatistics);
            }
          }
        }}
        sx={{ marginTop: '16px', marginLeft: 'auto' }}
      >
        Statistik anzeigen
      </Button>
    </Paper>
  );
}

export default StatisticsFilter;
